import {
    UPDATE_LINKED_PRODUCTS as SOURCE_UPDATE_LINKED_PRODUCTS,
    updateLinkedProducts as sourceUpdateLinkedProducts
} from 'SourceStore/LinkedProducts/LinkedProducts.action';

export const UPDATE_LINKED_PRODUCTS = SOURCE_UPDATE_LINKED_PRODUCTS;

export const updateLinkedProducts = sourceUpdateLinkedProducts;

export const UPDATE_LINKED_PRODUCTS_DATA = 'UPDATE_LINKED_PRODUCTS_DATA';

/** @namespace Bodypwa/Store/LinkedProducts/Action/updateLinkedProductsData */
export const updateLinkedProductsData = (
    items
) => ({
    type: UPDATE_LINKED_PRODUCTS_DATA,
    items
});
